function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dataops_service from '@/apps/dataops/services/dataops_service';
import firebase from 'firebase';
import Somos1Service from '@/apps/customer-insigths/services/somos1_service';
import { mapMutations } from 'vuex';
import * as XLSX from 'xlsx';
import tasks from '@/js/tasks';
export default {
  name: 'DashboardDictionaryUpload',
  props: {
    item: {
      type: Object,
      required: false,
      default: null
    }
  },
  components: {},
  mixins: [],
  data: function data() {
    var _this = this;
    return {
      valid: false,
      upload_form: false,
      hasFile: false,
      File: [],
      fileBase64: null,
      rules: {
        file: [function (v) {
          return !!v || _this.translate('customer_insights.rules.file');
        }, function (v) {
          return !v || v.size < 2000000 || _this.translate('customer_insights.rules.file_size');
        }]
      },
      form: {
        xlsx_file: null
      },
      viewsData: []
    };
  },
  beforeMount: function beforeMount() {},
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    onFileSelected: function onFileSelected() {
      var _this2 = this;
      if (!this.form.xlsx_file) {
        this.hasFile = false;
        return;
      }
      var reader = new FileReader();
      reader.onload = function (event) {
        var data = event.target.result;
        var workbook = XLSX.read(data, {
          type: 'binary'
        });
        var sheetName = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[sheetName];
        var json = XLSX.utils.sheet_to_json(worksheet);
        _this2.viewsData = json;
        _this2.fileBase64 = window.btoa(data); // Convertir a base64 para enviar
        _this2.hasFile = true;
      };
      reader.readAsBinaryString(this.form.xlsx_file);
    },
    dropFile: function dropFile(e) {
      this.File = e.dataTransfer.files;
      if (this.File.length > 0) {
        this.form.xlsx_file = e.dataTransfer.files[0];
        this.onFileSelected();
      }
    },
    save: function save() {
      var _this3 = this;
      if (this.$refs.form.validate()) {
        var file_string_binary = {
          'script_base64': this.fileBase64
        };
        dataops_service.importScripts(file_string_binary).then(function (response) {
          _this3.isLoading = false;
        });
      }
    },
    register: function register() {
      this.upload_form = true;
    },
    downloadTemplate: function downloadTemplate() {
      firebase.storage().ref('dashboard_dict_template/dashboard_dictionary.xlsx').getDownloadURL().then(function (url) {
        window.location = url;
      }).catch(function (error) {
        console.log(error);
      });
    },
    onUpdateDictionary: function onUpdateDictionary() {
      var _this4 = this;
      this.setShowLoading(true);
      var params = {
        data_update_dict: this.viewsData.map(function (row) {
          return {
            Pagina: row['Página'],
            Ventana: row.Ventana,
            Grafico: row.Grafico,
            TipoGrafico: row['Tipo Gráfico'],
            Descripcion: row['Descripción'],
            Formula: row.Formula,
            Fuente: row.Fuente,
            Automatizada: row['¿Automatizada?'],
            Proyecto: row.Proyecto,
            Dataset: row.Dataset,
            Tabla: row.Tabla
          };
        })
      };
      Somos1Service.updateDashboardDiccionary(this.item.document_id, params).then(function (response) {
        console.log(response);
        tasks.toast.success(_this4.translate('frases.successfully_registered'));
        _this4.$emit('submitAfterDictionaryUpdate');
      }).finally(function () {
        return _this4.setShowLoading(false);
      });
    }
  }),
  computed: {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    }
  }
};